import { Fragment, FC } from "react";
import { Box, Typography } from "@mui/material";
import { ConsentData } from "Constant/Arr";
import { PatientInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import ControlledForm from "Components/ControlledForm";
import { ConsentModalProps } from "DataTypes/PatientManagement.type";
import { CheckStringEmpty } from "Utils/common";
import SwitchCase from "Utils/SwitchCase";
import DateTime from "Utils/DateTime";

const ProgramConsentModal: FC<ConsentModalProps> = (props) => {
  const { changeDOE, doe, prgmName } = props;
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const formObj = {
    boxType: "date",
    id: "date",
    validatetype: "date",
    value: doe,
    minVal: "01/01/2015"
  }
  return (
    <Fragment>
      <Box>
        <Box sx={{ ...sxConHead }}>
          <Typography>New Consent Gained</Typography>
          <Box width="25%">
            <ControlledForm.MuiDatePicker
              id="enrollment"
              value={doe}
              label="Date Of Enrollment"
              onChange={(val) => changeDOE(CheckStringEmpty(val))}
              minVal="01/01/2015"
              maxVal={DateTime.CurrentDate()}
              error={
                SwitchCase.FormValidation(
                  JSON.parse(JSON.stringify(formObj))
                ).error
              }
              errorText={
                SwitchCase.FormValidation(
                  JSON.parse(JSON.stringify(formObj))
                ).errorText
              }
            />
          </Box>
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          sx={{ py: 2 }}
        >
          <Typography
            sx={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              mr: "10px",
            }}
          >
            Enrolled under Program:
          </Typography>
          <Typography
            variant="body2"
            sx={{
              p: 0.5,
            }}
          >
            {prgmName}
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: "1.2rem",
            pb: 2,

            fontWeight: 700,
          }}
        >
          Recipient:
        </Typography>
        <Typography variant="body2" sx={{ pb: 2 }}>
          {`${patientInfo.name} gave verbal
           consent for ${prgmName} services on ${doe}.`}
        </Typography>
        <Typography variant="body2" sx={{ pb: 2 }}>
          {"Beneficiary consented to " +
            prgmName +
            " services and the patient was explained the benefits."}
        </Typography>
        {ConsentData(prgmName || "").map((el) => {
          return (
            <Typography
              variant="body2"
              key={el.id}
            >{`(${el.id}) ${el.label}`}</Typography>
          );
        })}
      </Box>
    </Fragment>
  );
};

export default ProgramConsentModal;

const sxConHead = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  "& >p:first-of-type": {
    fontSize: "1.5rem",
    fontWeight: "bold",
    width: "100%",
  },
};